import { useState } from "react";
import { FcPrevious, FcNext } from "react-icons/fc";

const Paginator = (props) => {
    const [workingPage, setWorkingPage] = useState(1);

    const generatePageNumbers = () => {
        const totalPages = props.lastPage;
        const currentPage = workingPage;
        const maxPages = 10;
        const pages = [];

        let startPage, endPage;

        if (totalPages <= maxPages) {
            // Total pages less than or equal to max pages
            startPage = 1;
            endPage = totalPages;
        } else {
            // Total pages more than max pages
            if (currentPage <= Math.ceil(maxPages / 2)) {
                startPage = 1;
                endPage = maxPages;
            } else if (currentPage + Math.floor(maxPages / 2) >= totalPages) {
                startPage = totalPages - maxPages + 1;
                endPage = totalPages;
            } else {
                startPage = currentPage - Math.floor(maxPages / 2);
                endPage = currentPage + Math.floor(maxPages / 2);
            }
        }

        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }

        return pages;
    };

    const next = () => {
        if (workingPage < props.lastPage) {
            const newPage = workingPage + 1;
            setWorkingPage(newPage);
            props.pageChanged(newPage);
            //console.log(newPage + "|" + props.lastPage + "-");
        }
    };

    const prev = () => {
        if (workingPage > 1) {
            const newPage = workingPage - 1;
            setWorkingPage(newPage);
            props.pageChanged(newPage);
        }
    };

    return (
        <div className="grid px-4 py-3 text-xs font-semibold tracking-wide text-gray-500 uppercase border-t dark:border-gray-700 bg-gray-50 sm:grid-cols-9 dark:text-gray-400 dark:bg-gray-800">
            <span className="flex items-center col-span-3">
                {/* Showing {fromValues} 21-30 of 100 */}
            </span>
            <span className="col-span-2"></span>
            {/* <!-- Pagination --> */}
            <span className="flex col-span-4 mt-2 sm:mt-auto sm:justify-end">
                <nav aria-label="Table navigation">
                    <ul className="inline-flex items-center">
                        <li>
                            <button className="px-3 py-1 rounded-md rounded-l-lg focus:outline-none focus:shadow-outline-purple" aria-label="Previous" onClick={prev}>
                                <FcPrevious />
                            </button>
                        </li>
                        {generatePageNumbers().map((page, index) => (
                            <li key={index} className={`px-3 py-1 rounded-md focus:outline-none focus:shadow-outline-purple ${page === workingPage ? 'bg-purple-500 text-white' : ''}`} onClick={() => setWorkingPage(page)}>
                                <button onClick={() => props.pageChanged(page)}>
                                    {page}
                                </button>
                            </li>
                        ))}
                        <li>
                            <button className="px-3 py-1 rounded-md rounded-r-lg focus:outline-none focus:shadow-outline-purple" aria-label="Next" onClick={next}>
                                <FcNext />
                            </button>
                        </li>
                    </ul>
                </nav>
            </span>
        </div>
    );
};

export default Paginator;
